/** Protocollo dei messaggi tra UI e worker di routing. */

import type { LatLng } from '../lib/geo';
import type { PlanResult } from '../lib/route';
import type { HeatmapEdge, RouteShapeSegment, SweepPoint } from '../lib/sweep';

export interface ComputeParams {
  id: number;
  a: LatLng;
  b: LatLng;
  /** epoch ms della partenza */
  departMs: number;
  mode: 'auto' | { alpha: number };
}

export interface SweepParams {
  id: number;
  segments: RouteShapeSegment[];
  fromMs: number;
  stepMs: number;
  count: number;
}

export interface HeatmapParams {
  id: number;
  tMs: number;
}

export type WorkerRequest =
  | { type: 'compute'; params: ComputeParams }
  | { type: 'sweep'; params: SweepParams }
  | { type: 'heatmap'; params: HeatmapParams };

export type ProgressPhase = 'download' | 'graph' | 'route';

export const PHASE_LABELS: Record<ProgressPhase, string> = {
  download: 'Scarico strade, edifici e alberi da OpenStreetMap…',
  graph: 'Costruisco il grafo pedonale…',
  route: 'Calcolo ombre e percorsi…',
};

export interface DataMeta {
  ways: number;
  buildings: number;
  trees: number;
  canopies: number;
  vertices: number;
  edges: number;
  downloadMs: number;
  graphMs: number;
  routeMs: number;
  /** true se i dati OSM erano già in cache nel worker */
  fromCache: boolean;
}

export type WorkerResponse =
  | { type: 'progress'; id: number; phase: ProgressPhase }
  | { type: 'result'; id: number; plan: PlanResult; meta: DataMeta }
  | { type: 'sweep'; id: number; points: SweepPoint[] }
  | { type: 'heatmap'; id: number; tMs: number; edges: HeatmapEdge[] }
  | { type: 'error'; id: number; message: string };
